// Shared joint (two-insured) projection primitives. The universal
// MonthlyState.waitingPeriod slot is single-insured, so joint runs carry both
// spouses' elimination-period balances in strategyState (`JointWaitingPeriod`)
// and surface the active claimant's onto each row. See
// docs/joint-policy-strategies-plan.md A8.

export type Claimant = 'client' | 'partner';

export interface JointWaitingPeriod {
  client: WaitingPeriodState;
  partner: WaitingPeriodState;
}

// Seed each spouse's EP. Distinct copies so they decrement independently.
// `partnerSeed` defaults to `clientSeed` for strategies whose seed carries no
// in-flight (mid-EP) state; pass an explicit partner seed whenever the client
// seed embeds `...WaitingPeriodDaysRemaining` partial credit (see below).
export function seedJointWaitingPeriod(
  clientSeed: WaitingPeriodState,
  partnerSeed: WaitingPeriodState = clientSeed,
): JointWaitingPeriod {
  return { client: { ...clientSeed }, partner: { ...partnerSeed } };
}

// The policy schema has a single homeCare/facilityCareWaitingPeriodDaysRemaining
// pair with no per-claimant variant; by convention it describes the PRIMARY
// CLIENT's in-flight claim. So only the client may open mid-EP with partial
// credit — the partner always serves the policy's full elimination period,
// which is what this seed builds (deliberately ignoring `...DaysRemaining`).
export function partnerWaitingPeriodSeed(ltcPolicy: PolicyFundingSource): WaitingPeriodState {
  return {
    homeDays: ltcPolicy.homeCareWaitingPeriodDays ?? 0,
    facilityDays: ltcPolicy.facilityCareWaitingPeriodDays ?? 0,
  };
}
